<script>
  import { appSession, appConstants } from "../stores/app.js";
  import SelectAirport from "../components/SelectAirport.svelte";
  //  import DateField from "../components/DateField.svelte";
  import RestEmptyLegSearch from "../components/RestEmptyLegSearch.svelte";
  import RestJumpseatRequests from "../components/RestJumpseatRequests.svelte";
  import EmptyLegFormatter from "../components/EmptyLegFormatter.svelte";
  //  import JsRequestFormatter from "../components/JsRequestFormatter.svelte";
  import MyModal from "../components/MyModal.svelte";
  //  import { DateValid } from "../library/util.js";
  import * as yup from "yup";
  import { DateTime } from "luxon";

  let busy = false;
  let restEmptyLegSearch = null;
  let restJumpseatRequests = null;
  let results = [];
  let searchCompleted = false;
  let myModal = null;
  //  let enquiryEmptyLeg = null;
  let pendingCount = 0;

  let form = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      fromairportid: 0,
      toairportid: 0,
      date: "",
    },

    schema: yup.object().shape({
      fromairportid: yup.number().test("fromairportid", "Departure or Arrival aiport required", (value) => {
        if (value > 0) return true;
        else {
          if (form.data.toairportid == 0) return false;
          else return true;
        }
      }),

      toairportid: yup.number().test("toairportid", "Departure or Arrival aiport required", (value) => {
        if (value > 0) return true;
        else {
          if (form.data.fromairportid == 0) return false;
          else return true;
        }
      }),
    }),
    errors: null,
  };

  let fromAirportIdSelected = null;
  let toAirportIdSelected = null;
  $: {
    if (fromAirportIdSelected != null) form.data.fromairportid = fromAirportIdSelected.airportid;
    if (toAirportIdSelected != null) form.data.toairportid = toAirportIdSelected.airportid;
  }

  function ValidateForm() {
    return new Promise(function (resolve, reject) {
      form.schema
        .validate(form.data, { abortEarly: false })
        .then((values) => {
          form.valid = true;
          form.errors = {};
          resolve();
        })
        .catch((validationErrors) => {
          console.log(validationErrors);
          form.valid = false;
          form.errors = {};

          for (let i = 0; i < validationErrors.inner.length; i++) {
            let error = validationErrors.inner[i];
            form.errors[error.path] = {
              type: error.type,
              message: typeof error.errors[0] == "object" ? error.errors[0].message : error.errors[0],
            };
          }

          reject("InvalidForm");
        });
    });
  }

  async function Search() {
    try {
      await ValidateForm();
      busy = true;
      results = await restEmptyLegSearch.GetEmptyLegs(form.data.fromairportid, form.data.toairportid);

      results.forEach((leg) => {
        leg.datetime = DateTime.fromSQL(leg.datetime);
        leg.datetimelocal = DateTime.fromSQL(leg.datetimelocal);
        const gmtDiff = leg.datetimelocal.diff(leg.datetime, "hours");
        gmtDiff.toObject();
        leg.gmtoffset = gmtDiff.as("hours") < 0 ? gmtDiff.as("hours") : "+" + gmtDiff.as("hours");
      });

      searchCompleted = true;

      busy = false;
    } catch (error) {
      busy = false;
      switch (error) {
        case "InvalidForm":
          break;
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, operatorId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  }

  function handleKeydown(e) {
    if (e.key == "Enter") Search();
  }

  async function request(emptyLeg) {
    // count pending requests
    let requests = await restJumpseatRequests.GetJumpseatRequestList("fields=status&status=eq:pending");
    pendingCount = 0;
    requests.forEach((request) => {
      pendingCount++;
    });

    // limit reached
    if (pendingCount >= $appConstants.pendingRequestLimit) {
      await myModal.showAlert(
        "Pending request limit reached",
        "Sorry, a maximum of " + $appConstants.pendingRequestLimit + " pending jumpseat requests is permitted."
      );
      return;
    }

    let confirmed = await myModal.showConfirm(
      "Confirm request",
      "Please confirm your jumpseat request for this empty leg.",
      {
        buttonOk: "Confirm",
      }
    );
    if (!confirmed) return;

    let fields = {
      emptylegid: emptyLeg.emptylegid,
      date: emptyLeg.datetime.toFormat("y-LL-dd"),
      time: emptyLeg.datetime.toFormat("HH:mm"),
    };

    await restJumpseatRequests.PostJumpseatRequest(fields);

    setTimeout(() => {
      M.toast({ html: "Jumpseat request submitted" }, { displayLength: 3000 });
    }, 500);
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<div style="padding-bottom: 40px; padding-top: 20px;">
  <div
    class="row"
    style="display: flex; flex-wrap: wrap; flex-direction: row; justify-content: flex-start; align-items: flex-start;"
  >
    <div class="col s12 m6 l6">
      <label class="active" style="display: block;">
        Departing <span style="font-size: 0.7em;">Enter airport code or name</span>
      </label>
      <div class="svelte-select">
        <SelectAirport
          bind:selectedValue={fromAirportIdSelected}
          onClear={(e) => {
            form.data.fromairportid = 0;
            fromAirportIdSelected = null;
          }}
        />

        <div class="input-field" style="margin-top: 0.5em;">
          {#if form.errors && form.errors.fromairportid}
            <span class="helper-text red-text">{form.errors.fromairportid.message}</span>
          {/if}
        </div>
      </div>
    </div>

    <div class="col s12 m6 l6">
      <label class="active" style="display: block;">
        Arriving <span style="font-size: 0.7em;">Enter airport code or name</span>
      </label>
      <div class="svelte-select">
        <SelectAirport
          bind:selectedValue={toAirportIdSelected}
          onClear={(e) => {
            form.data.toairportid = 0;
            toAirportIdSelected = null;
          }}
        />

        <div class="input-field" style="margin-top: 0.5em;">
          {#if form.errors && form.errors.toairportid}
            <span class="helper-text red-text">{form.errors.toairportid.message}</span>
          {/if}
        </div>
      </div>
    </div>

    <div class="col s12" style="text-align: right;">
      <button class="btn waves-effect btn-small blue-grey" on:click={Search}>Search</button>
    </div>
  </div>

  {#if busy}
    <div style="display: flex; justify-content: center;">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-green-only">
          <div class="circle-clipper left">
            <div class="circle" />
          </div>
          <div class="gap-patch">
            <div class="circle" />
          </div>
          <div class="circle-clipper right">
            <div class="circle" />
          </div>
        </div>
      </div>
    </div>
  {:else if searchCompleted}
    {#if results.length > 0}
      <div style="text-align: center; font-size: 9pt; font-weight: 500;">
        Showing {results.length} empty legs, click to request.
      </div>

      {#each results as emptyLeg}
        <div
          class="search-result"
          on:click={() => {
            request(emptyLeg);
          }}
        >
          <EmptyLegFormatter {emptyLeg} />
        </div>
      {/each}
    {:else}
      <div style="text-align: center; margin-top: 50px; font-weight: bold;">No results found</div>
    {/if}
  {:else}
    <div
      style="text-align: center; width: 80%; padding: 10px 20px; background: #f1f1f1; margin: 50px auto; box-sizing: border-box; border-radius: 4px;"
    >
      <p><b>Search Tips</b></p>
      <p>Enter the departure airport, arrival airport or both.</p>
      <p>
        Jumphub searches empty legs in the vacinity of departure and/or destination airports within the next 14 days.
      </p>
    </div>
  {/if}
</div>

<RestEmptyLegSearch bind:this={restEmptyLegSearch} />
<RestJumpseatRequests bind:this={restJumpseatRequests} />
<MyModal bind:this={myModal} />

<style>
  .search-result {
    cursor: pointer;
    padding: 5px 4px;
    box-sizing: border-box;
    border-bottom: solid 1px #c7c7c7;
  }
  .search-result:hover {
    background-color: #f9f9f9;
  }

  /* colour tabs - no in use at moment
  .tabs .tab a {
    color: #1c3b57;
  } 

  .tabs .tab a:hover {
    background-color: none !important;
    color: #1c3b57;
  }

  :global(.tabs .tab a.active) {
    background-color: none !important;
    color: #1c3b57 !important;
  } 

  :global(.tabs .indicator) {
    background-color: #1c3b57 !important;
  } 

  :global(.tabs .tab a:focus, .tabs .tab a:focus.active) {
    background-color: rgba(255, 255, 255, 1) !important;
  } */
</style>
